import { render, staticRenderFns } from "./SentimentMarketValue.vue?vue&type=template&id=628e4a57&scoped=true"
import script from "./SentimentMarketValue.vue?vue&type=script&lang=js"
export * from "./SentimentMarketValue.vue?vue&type=script&lang=js"
import style0 from "./SentimentMarketValue.vue?vue&type=style&index=0&id=628e4a57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e4a57",
  null
  
)

export default component.exports